import { ListingInput } from "@/Schemas/Listing/ListingInput";
import { ListingOutput, ListingOutputSchema } from "@/Schemas/Listing/ListingOutput";
import { getQueryString } from "vig-ui-library";
import axios from "@/axios";
import { parseSchema } from "@/Utils/zodParser";

export const getListData = async (input: ListingInput, path: string): Promise<ListingOutput> => {
    const dateFrom = input.dateFrom?.toISOString().split("T")[0];
    const dateTo = input.dateTo?.toISOString().split("T")[0];
    const queryString = getQueryString({ ...input, dateFrom, dateTo });
    const url = `${path}?${queryString}`;
    const response = await axios.get(url);
    return parseSchema(ListingOutputSchema, { ...response.data, items: response.data.items || [] });
}

export const getList = async (input: ListingInput): Promise<ListingOutput> => {
    return getListData(input, "/api/listing");
}

export const getMyList = async (input: ListingInput): Promise<ListingOutput> => {
    return getListData(input, "/api/listing/my");
}